module.exports = "<svg id=\"5b7a8df1-7945-4603-af80-372e0fda8a83\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>quotes</title><path d=\"M20.44,8.07c-6.38,0-11.38,2-15,5.92S0,24.12,0,32.53V50H21V31.13H10.87c0-4.62.76-8.06,2.24-10.31s3.92-3.38,7.33-3.38V8.07Zm28.82,0A23.56,23.56,0,0,0,40.74,9.5a16,16,0,0,0-6.39,4.44,20.49,20.49,0,0,0-4,7.67,38.21,38.21,0,0,0-1.4,10.92V50H50V31.13H39.87q0-6.93,2.22-10.31t7.17-3.38V8.07Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/quotes-01.svg
// module id = 514
// module chunks = 1